import React from 'react';
import classNames from 'classnames';
import { I18n } from '@fiverr-private/fiverr_context';
import { baseTranslationButtonProps } from '../../../utils/props';
import withTranslationButtonWrapper from '../TranslationButtonWrapper';
import TranslationButton from '../TranslationButton';

import './style.scss';

const LeanDefaultTranslationButton = ({
    toggled = false,
    loading = false,
    onClick = Function.prototype
}) => {
    const titleSuffix = !toggled || loading ? 'translate' : 'see_original';

    return (
        <TranslationButton className={classNames('lead-default', { toggled, 'is-loading': loading })}
            showGoogleMTExperience={false}
            onClick={onClick}
            loading={loading}
            toggled={toggled}>
            <I18n k={`machine_translation.${titleSuffix}`}/>
        </TranslationButton>
    );
};

LeanDefaultTranslationButton.propTypes = baseTranslationButtonProps;

export default withTranslationButtonWrapper(LeanDefaultTranslationButton);
